<template>
  <div>
    <div class="header">
      <h1 class="page-title">消费明细</h1>
    </div>
    <el-card class="box-card">
      <div slot="header" class="card_header clearfix">
        <div class="block">
          <span>下单日期</span>
          <el-date-picker
            v-model="value2"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="date()"
          ></el-date-picker>
          <input type="text" v-model="keywords" placeholder="请输入您要搜索的内容" />
          <button class="searchBtn" @click="selectconsume()">搜索</button>
        </div>
        <div class="totalInfo">
          <span>
            总订单数:
            <i>{{totalNum + '条'}}</i>
          </span>
          <!-- <span>
            总重量:
            <i>11111</i>
          </span>
          <span>
            总运费:
            <i>11111</i>
          </span>
          <span>
            总价格:
            <i>11111</i>
          </span>-->
        </div>
      </div>

      <div class="main">
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column type="index" width="60" :index="indexMethod" label="序号"></el-table-column>
          <el-table-column width="120" prop="order_no" label="订单号"></el-table-column>
          <el-table-column prop="total_price" label="订单金额(元)"></el-table-column>
          <el-table-column width="400" prop="file" label="文件名"></el-table-column>
          <el-table-column prop="remarks" label="订单备注"></el-table-column>
          <el-table-column prop="arter_price" label="售后金额(元)">
            <template slot-scope="scope">{{scope.row.after_price +'' }}</template>
          </el-table-column>
          <el-table-column prop="payway" label="支付方式"></el-table-column>
          <el-table-column prop="bussiness_no" label="流水号"></el-table-column>
          <el-table-column prop="createtime" label="支付时间">
            <template slot-scope="scope">{{scope.row.createtime | dateFormat}}</template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
        :total="totalNum"
      ></el-pagination>
    </el-card>

    <a
      :href="baseUrl + `/api/mine/consume/explode/1/uid/${uId}${mindate==''?'':`/mindate/${mindate}`}${maxdate==''?'':`/maxdate/${maxdate}`}${keywords==''?'':`/keywords/${keywords}`}`"
      id="exportTable"
      class="btn btn-default"
    >导出excel</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 时间
      value2: '',
      token: window.localStorage.getItem('token'),
      mindate: '',
      maxdate: '',
      page: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      tableData: [],
      totalNum: 0,
      loading: true,
      keywords: '',
      uId: '',
      baseUrl: ''
    }
  },
  created() {
    const url = window.location.host
    this.baseUrl = !url.includes('192')
      ? 'http://' + url
      : 'https://www.yunshanyin.net'
    if (window.localStorage.getItem('u')) {
      let u = window.localStorage.getItem('u')
      this.uId = JSON.parse(u).id
    }
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.queryConcume()
    this.getYue()
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    indexMethod(index) {
      if (this.page == 1) {
        return index + 1
      }
      if (index + 1 == 10) {
        return this.page + '' + 0
      }
      return this.page - 1 + '' + (index + 1)
    },
    handleCurrentChange(value) {
      this.page = value
      this.queryConcume()
    },
    // 补0
    PrefixInteger(num, length) {
      return ('00000000' + num).substr(-length)
    },
    // 搜素
    selectconsume() {
      this.page = 1
      this.queryConcume()
    },
    // 时间
    date() {
      if (this.value2 != null) {
        this.mindate = this.value2[0] + ' 00:00:00'
        this.maxdate = this.value2[1] + ' 23:59:59'
      } else {
        this.mindate = ''
        this.maxdate = ''
      }
    },
    //   消费，明细
    async queryConcume() {
      this.loading = true
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('page', this.page)
      param.append('mindate', this.mindate)
      param.append('maxdate', this.maxdate)
      param.append('keywords', this.keywords)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/consume',
        data: param
      })
      this.loading = false
      if (res.code === 1) {
        this.tableData = res.data.data
        this.totalNum = res.data.total_num
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.card_header {
  position: relative;
  .totalInfo {
    position: absolute;
    top: 50px;
    right: 20px;
    span {
      font-size: 18px;
      margin-right: 18px;
      i {
        color: #e83030;
      }
    }
  }
}
.el-card {
  .block {
    position: relative;
    margin-top: 30px;
    span {
      margin-right: 10px;
      color: #666;
    }
    input {
      box-shadow: 0px 0px 1px 1px #eee;
      padding-left: 10px;
      margin-left: 30px;
      width: 220px;
      height: 30px;
    }
    .searchBtn {
      padding: 8px 20px;
      margin-top: 5px;
      margin-left: 15px;
      color: #fff;
      background: #a77c5a;
      border-radius: 3px;
    }
    .sy-zongj {
      position: absolute;
      top: 13px;
      left: 800px;
      font-size: 16px;
      b {
        color: #e83030;
      }
    }
  }
  .main {
    font-size: 12px;
    .cz {
      font-size: 12px !important;
      margin-left: 5px;
    }
  }
  .el-pagination {
    margin: 40px 0 0 700px;
  }
}
</style>